import { Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { PageLayout } from "./components/PageLayout";
import { useThemeContext } from "./styles/ThemeContextProvider";
import { SignIn } from "./pages/Signin";
import { Register } from "./pages/Register";
import { ProtectedRoutes } from "./components/ProtectRoutes";
import NotFound from "./pages/404";
import "./App.css";
import NotificationSettings from "./components/NotificationSettings";
import { ResetPassword } from "./pages/ResetPassword";
import { Sites } from "./pages/Sites";
import { Distributors } from "./pages/Distributors";
import { Account } from "./pages/Account";
import { Notifications } from "./pages/NotificationHub";
import { HealthDashboard } from "./pages/HealthDashboard";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { useAuth } from "./utils/AuthProvider";
import { WalkthroughProvider } from "./utils/WalkthroughProvider";
import WalkthroughOverlay from "./components/WalkthroughOverlay";
import { canAccessManagement, canViewDistributors } from "./utils/permissions";

function App() {
  const { theme } = useThemeContext();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <WalkthroughProvider>
        <PageLayout>
          <Pages />
        </PageLayout>
        <WalkthroughOverlay />
      </WalkthroughProvider>
    </ThemeProvider>
  );
}

function Pages() {
  const { cookies } = useAuth();
  return (
    <Routes>
      {/* public routes */}
      <Route path="/signin" element={<SignIn />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />

      {/* we want to protect these routes */}
      <Route element={<ProtectedRoutes />}>
        <Route path="/" element={<HealthDashboard />} />
        <Route path="settings" element={<NotificationSettings />} />
        {canAccessManagement(cookies.role) && (
          <Route path="sites" element={<Sites />} />
        )}
        {canViewDistributors(cookies.role) && (
          <Route path="distributors" element={<Distributors />} />
        )}
        <Route path="account" element={<Account />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="healthDashboard" element={<Navigate to="/" replace />} />
      </Route>

      {/* catch all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;